import { render } from "./AccountView.vue?vue&type=template&id=f6c92354&scoped=true&lang=pug"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import "./AccountView.scss?vue&type=style&index=0&id=f6c92354&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c92354"]])

export default __exports__